import ons from 'onsenui';
import { translate as _ } from './i18n';

const defaultMessageTimeout = 4000;

export const generalError = () => {

    ons.notification.alert( {
        message: _( 'Ein unbekannter Fehler ist aufgetreten. Bitte probiere es später noch einmal.' ),
        title:   _( 'Fehler' )
    } );

};

export const showAlert = options => {

    ons.notification.alert( {

        ...options

    } );

};

export const showMessage = options => {

    ons.notification.toast( {

        buttonLabel: '<i class="fa fa-times"></i>',
        timeout:     defaultMessageTimeout,

        ...options

    } );

};